import {
  AtlasLabelField,
  type AtlasLabelFieldProps,
} from "@/components/form/AtlasLabelField";
import { useFormField } from "@/components/ui/form";
import { cn } from "@/lib/utils";

export interface AtlasThemeLabelFieldProps extends AtlasLabelFieldProps {
  /**
   * Additional wrapper class for form field container
   */
  wrapperClassName?: string;
}

function AtlasThemeLabelField({
  className,
  variant = "default",
  size = "default",
  wrapperClassName,
  error,
  ...props
}: AtlasThemeLabelFieldProps) {
  // Get the form field context for proper ID association
  const { formItemId } = useFormField();

  // Determine variant based on error prop
  const effectiveVariant = error ? "error" : variant;

  return (
    <div className={cn("w-full", wrapperClassName)}>
      <AtlasLabelField
        id={formItemId}
        className={className}
        variant={effectiveVariant}
        size={size}
        error={error}
        {...props}
      />
    </div>
  );
}

AtlasThemeLabelField.displayName = "AtlasThemeLabelField";

export { AtlasThemeLabelField };
